import { sizeOfPortfolio } from '../features/Registration/constants/UnitOptions';

export const isUserSMB = (selectedSizeOfPortfolio: sizeOfPortfolio | undefined): boolean => {
  if (!selectedSizeOfPortfolio) {
    return false;
  }

  return [
    sizeOfPortfolio.oneToFifty,
    sizeOfPortfolio.oneToTen,
    sizeOfPortfolio.elevenToFifty,
    sizeOfPortfolio.fiftyOneToTwoHundred,
  ].includes(selectedSizeOfPortfolio);
};
